import html2canvas, { Options } from "html2canvas";

export const takeSnapshot = async (
  element: HTMLElement,
  options: Partial<Options> = {}
) => {
  try {
    const canvas = await html2canvas(element, {
      useCORS: true,
      allowTaint: true,
      windowWidth: 640,
      // windowHeight: 800,
      scale: 2,
      ignoreElements(element) {
        return (
          element.tagName === "CANVAS" ||
          element.classList.contains("snapshot-ignore")
        );
      },
      ...options,
    });
    return canvas.toDataURL("image/png");
  } catch (error) {
    console.error(error);
  }
};
